import { makeSceneDoc } from '../kit.js';

/**
 * 河埠：货栈、货船和别人的委托。
 * 三家商号共用一个埠头，清晨尤其忙。
 */
export const riverfrontDoc = makeSceneDoc({
  id: 'riverfront',
  name: '河埠',
  region: 'city',
  tier: 2,
  node: 'riverfront',
  desc: '船帮靠岸的地方，空气里是水腥气和麻绳味。',
  w: 46, h: 26,
  fill: 'o',
  spawn: { gx: 3, gy: 12 },
  draw(b, rng) {
    b.rect(0, 0, 46, 26, 'o');
    b.rect(38, 0, 8, 26, 'w');                     // 河道
    b.rect(35, 0, 3, 26, 'e');
    b.rect(0, 0, 4, 26, ',');
    // 木地板只铺房子坐的那几格，门前留一格门槛，别让人绕到屋后头去
    b.rect(11, 6, 4, 2, '.');      b.set(12, 8, '+');    // 货栈
    b.rect(11, 21, 3, 2, '.');     b.set(12, 23, '+');   // 早点铺
    for (let y = 6; y < 20; y += 1) b.set(36, y, 'n'); // 栈桥
    b.rect(30, 10, 5, 6, ',');
  },
  props: [
    { type: 'cargo_office', gx: 13, gy: 4 },
    { type: 'shipping_board', gx: 14, gy: 11 },
    { type: 'wrecked_tugboat', gx: 36, gy: 12 },
    { type: 'cargo_boat', gx: 36, gy: 8 },
    { type: 'cotton_goods_stall', gx: 20, gy: 6 },
    { type: 'hemp_goods_stall', gx: 24, gy: 6 },
    { type: 'dye_stall', gx: 20, gy: 18 },
    { type: 'oil_jar_stall', gx: 26, gy: 18 },
    { type: 'liquor_vat', gx: 30, gy: 14 },
    { type: 'grain_vat', gx: 31, gy: 14 },
    { type: 'riverside_junk', gx: 28, gy: 22 },
    { type: 'riverside_junk', gx: 22, gy: 12 },
  ],
  portals: [
    { to: 'market', gx: 1, gy: 12, spawn: [43, 20], label: '市集' },
    { to: 'depot', gx: 12, gy: 8, spawn: [7, 13], label: '货栈' },
    { to: 'eatery', gx: 12, gy: 23, spawn: [6, 13], label: '早点铺' },
  ],
});

export default riverfrontDoc;
